import { IUpdateFuncionarioAprovadorUseCase } from "../../../presentation/useCases/update/update_funcionario_aprovador_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

export class UpdateFuncionarioAprovadorUseCase implements IUpdateFuncionarioAprovadorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateFuncionarioAprovador(
    idFuncionarioAprovador: number,
    funcionarioEmail: string,
    valorMaximo: number | null,
  ): Promise<void> {
    await this.repository.updateFuncionarioAprovador(idFuncionarioAprovador, funcionarioEmail, valorMaximo);
  }
}
